import { FlexBase, FlexTag } from "../Flex/Flex";

export class P extends FlexBase<"p"> {
  tag: FlexTag = "p";
}
